import { adminClient, inferAdditionalFields } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

/**
 * Same-origin in both environments: Vite proxies `/api` to Fastify in development,
 * and Fastify serves this bundle in production. No `baseURL` means no cross-site
 * cookie handling to get wrong.
 */
export const authClient = createAuthClient({
  basePath: '/api/auth',
  plugins: [
    adminClient(),
    inferAdditionalFields({
      user: {
        firstName: { type: 'string', required: false },
        lastName: { type: 'string', required: false },
        accountStatus: { type: 'string', required: false },
        institutionId: { type: 'string', required: false },
      },
    }),
  ],
})

export const { signIn, signUp, signOut, useSession } = authClient

/** Better Auth returns errors as `{ error: { message, code } }` rather than throwing. */
export function authErrorMessage(error: { message?: string; code?: string } | null): string | null {
  if (!error) return null
  switch (error.code) {
    case 'ACCOUNT_PENDING':
    case 'ACCOUNT_REJECTED':
    case 'ACCOUNT_SUSPENDED':
      return error.message ?? 'This account cannot sign in yet.'
    case 'INVALID_EMAIL_OR_PASSWORD':
      return 'Those credentials were not recognised.'
    case 'EMAIL_NOT_VERIFIED':
      return 'Verify your email address before signing in.'
    default:
      return error.message ?? 'Something went wrong. Try again.'
  }
}
